import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=681d4ac8&scoped=true&lang=html"
import script from "./Material.vue?vue&type=script&lang=js"
export * from "./Material.vue?vue&type=script&lang=js"
import style0 from "./Material.vue?vue&type=style&index=0&id=681d4ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d4ac8",
  null
  
)

export default component.exports